
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.517 8.992a12.624 12.624 0 005.491 5.491l1.834-1.833a.829.829 0 01.85-.2 9.506 9.506 0 002.975.475c.458 0 .833.375.833.833v2.909a.836.836 0 01-.833.833C8.842 17.5 2.5 11.158 2.5 3.333c0-.458.375-.833.833-.833H6.25c.458 0 .833.375.833.833 0 1.042.167 2.042.475 2.975a.836.836 0 01-.208.85L5.517 8.992z"}})])
          )
        }
      }
    